import Contact from '../../Components/Contact/Contact'
import ZohoId from '../../Components/ZohoId/ZohoId'
import DoorToDoorPartnerChecklist from '../../Components/DoorToDoorPartnerChecklist/DoorToDoorPartnerChecklist'
import McpAdvisor from '../../Components/McpAdvisor/McpAdvisor'
import SalesScript from '../../Components/SalesScript/SalesScript'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
// McpAdvisor self-gates its visibility (Selectra admin + FR + assigned advisor).
const ContactTab = () => {
  return (
    <div style={{ width: '100%' }}>
      <ZohoId />
      <SalesScript />
      <DoorToDoorPartnerChecklist />
      <Contact />
      <McpAdvisor />
    </div>
  )
}

export default ContactTab
